// Used in assignment-info-dialog.component.html and tiles.component.html

// Angular
import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "assessment-directions",
    templateUrl: "./assessment-directions.component.html",
    styleUrls: [
        "./assessment-directions.component.scss",
        "../../../styles/shared-styles.scss",
    ],
    standalone: false
})
export class AssessmentDirectionsComponent implements OnInit {
    @Input() assessmentDirection: string;
    @Input() fontSize: string;

    constructor() {}

    ngOnInit(): void {}
}
